import { Dialog } from "@fluentui/react-northstar";
import styled from "styled-components";

export const DialogOTP = styled(Dialog)`
    width: 453px;
    padding: 28px 24px 32px 24px;
    gap: 16px;
    border-radius: 4px;

    box-shadow: 0px 2.4px 7.4px 0px rgba(0, 0, 0, 0.18),
        0px 12.8px 28.8px 0px rgba(0, 0, 0, 0.22);
`;
